import { Component, h, Prop, Element, State } from '@stencil/core';

@Component({
  tag: 'a1-list',
  styleUrl: 'a1-list.scss',
  scoped: true,
})
export class A1List {
  @State() private listNodes: HTMLLIElement[] = [];

  @Element() private element!: HTMLA1ListElement;

  /**
   * Icon type for list items.
   */
  @Prop({ reflect: true }) icon: string = 'dot';

  /**
   * List items.
   */
  @Prop({ reflect: true }) items: string = '';

  /**
   * Colorful list.
   */
  @Prop({ reflect: true }) colorful: boolean = false;

  /**
   * HTML text to render
   */
  @Prop({ reflect: true }) htmlText: boolean = false;

  componentWillLoad() {
    if (this.htmlText) {
      this.listNodes = Array.from(this.element.querySelectorAll('li'));
    }
    this.element.innerHTML = '';
  }

  private getIconNode() {
    return <span class={`icon c-icon--${this.icon || 'dot'} list--bullet`}></span>;
  }

  render() {
    let listItems = this.items || '';

    listItems = listItems.replace(/&quot;/g, '"');
    listItems = listItems.replace(/<\/?p>/g, '');
    listItems = listItems.replace(/<br>/g, '');
    listItems = listItems.replace(/'/g, '');
    const listItemArr = listItems ? JSON.parse(listItems) : [];

    return (
      <ul
        class={{
          'list': true,
          'list--colorful': this.colorful || false,
        }}
      >
        {!this.htmlText
          ? listItemArr.map((item: string) => (
              <li class="list--item">
                {this.getIconNode()}
                <span class="list--text">{item}</span>
              </li>
            ))
          : this.listNodes.map(node => (
              <li class={`list--item ${node.classList}`}>
                {!node.querySelector('a1-icon') ? this.getIconNode() : null}
                <span class="list--text" innerHTML={node.innerHTML}></span>
              </li>
            ))}
      </ul>
    );
  }
}
